module.exports = __webpack_public_path__ + "static/media/investment.c69c5ed0.png";